/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentsFromJSON, FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentsToJSON, } from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocuments';
import { FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTOFromJSON, FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTOToJSON, } from './FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTO';
import { FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInappFromJSON, FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInappToJSON, } from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInapp';
import { FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLoginFromJSON, FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLoginToJSON, } from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLogin';
import { FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCodeFromJSON, FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCodeToJSON, } from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCode';
import { FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStoreFromJSON, FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStoreToJSON, } from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStore';
import { FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHubFromJSON, FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHubToJSON, } from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHub';
/**
 * Check if a given object implements the FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatures interface.
 */
export function instanceOfFxIdApplicationHandlersNativeStatusNativeStatusDtoFeatures(value) {
    if (!('Login' in value) || value['Login'] === undefined)
        return false;
    if (!('Store' in value) || value['Store'] === undefined)
        return false;
    if (!('PushTokens' in value) || value['PushTokens'] === undefined)
        return false;
    if (!('Hub' in value) || value['Hub'] === undefined)
        return false;
    if (!('Documents' in value) || value['Documents'] === undefined)
        return false;
    if (!('PromoCode' in value) || value['PromoCode'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesFromJSON(json) {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Login': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLoginFromJSON(json['login']),
        'Store': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStoreFromJSON(json['store']),
        'Inapp': json['inapp'] == null ? undefined : FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInappFromJSON(json['inapp']),
        'PushTokens': FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTOFromJSON(json['push_tokens']),
        'Hub': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHubFromJSON(json['hub']),
        'Documents': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentsFromJSON(json['documents']),
        'PromoCode': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCodeFromJSON(json['promo_code']),
    };
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesToJSON(json) {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesToJSONTyped(json, false);
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'login': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLoginToJSON(value['Login']),
        'store': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStoreToJSON(value['Store']),
        'inapp': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInappToJSON(value['Inapp']),
        'push_tokens': FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTOToJSON(value['PushTokens']),
        'hub': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHubToJSON(value['Hub']),
        'documents': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentsToJSON(value['Documents']),
        'promo_code': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCodeToJSON(value['PromoCode']),
    };
}
//# sourceMappingURL=FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatures.js.map